module.exports = __webpack_public_path__ + "static/img/cstSer_bg_white_12.96094ac4.svg";